// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__GgZpr","closeButton":"styles_closeButton__35bnl","dialogTitle":"styles_dialogTitle__2yS34"};